import React, { CSSProperties } from 'react'

interface IProps {
  refresh: (data: any) => void;
  observe?: (data: IntersectionObserverEntry) => void;
  data: any;
  threshold?: number;
  styles?: CSSProperties;
  first?: boolean;
}

class AdScrollRefresh extends React.PureComponent<IProps> {
  static defaultProps = {
    refresh: true,
    data: {},
    threshold: 0.75
  }
  private adRef = React.createRef<HTMLDivElement>();
  private first: boolean = false;
  componentDidMount() {
    const { data, refresh, threshold, observe, first } = this.props;
    let ref = this.adRef.current;

    this.first = !!first

    try {
      let io = new IntersectionObserver(
        entries => {
          if (this.first) {
            if (entries[0].isIntersecting) {
              refresh(data);
            }
          } else {
            this.first = true
          }
          observe && observe(entries[0]);
        }, {
        threshold: [threshold as number],
      });
      if (ref) {
        io.observe(ref);
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { children, styles } = this.props;

    return (
      <div ref={this.adRef} style={{ display: 'inline-block', ...styles }}>
        {children}
      </div>
    );
  }
}

export default AdScrollRefresh;